<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 10:01:59
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 10:03:43
 * @FilePath: \vue-privilege-routing\src\pages\resource\material-manage\index.vue
-->
<template>
    <div>
       物料管理
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
